import animations from './animations'
import borders from './borders'
import colors from './colors'
import durations from './durations'
import fonts from './fonts'
import fontSizes from './fontSizes'
import fontWeights from './fontWeights'
import gridTemplateColumns from './gridTemplateColumns'
import gridTemplateRows from './gridTemplateRows'
import radii from './radii'
import ringWidths from './ringWidths'
import screens from './screens'
import shadows from './shadows'
import sizes from './sizes'
import spaces from './spaces'
import timingFunctions from './timingFunctions'
import transformers from './transformers'
import transforms from './transforms'
import transitions from './transitions'
import zIndices from './zIndices'

export default {
  animations,
  borders,
  colors,
  durations,
  fonts,
  fontSizes,
  fontWeights,
  gridTemplateColumns,
  gridTemplateRows,
  radii,
  ringWidths,
  screens,
  shadows,
  sizes,
  spaces,
  transformers,
  transforms,
  transitions,
  timingFunctions,
  zIndices,
}
